<div class="row justify-content-center">
    <div class="col-6">
        <div>
            <div class="iframe-wrapper">
                <iframe  width="100%" [ngStyle]="{'height.px':iframeHeight}" [src]="iFrameUrl | safe"  id="i-frame" (load)="initIframe()"></iframe>
            </div>
        </div>
    </div>
</div>
